package music.jammers.client.shared.component.card.info.presentation.viewmodel

import music.jammers.shared.event.domain.model.CardInfo

data class CardInfoState(
    val items: List<CardInfo> = emptyList(),
    val selected: CardInfo? = null,
    val error: Throwable? = null,
)